import React from 'react';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mb-4" />
        <p className="text-gray-300 text-lg font-heading uppercase tracking-widest">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
